var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a024b51b-5384-492f-a820-df7f9d48e0e7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-8ec62a71-dd3c-42c7-aeea-444233969ade{fill:#fff;}.uuid-0ea754f9-13da-4021-ab15-134b2e5494a1{fill:#2998e3;}.uuid-0ea754f9-13da-4021-ab15-134b2e5494a1,.uuid-76e8569b-bfc5-4c90-8d9a-83164b1f884f,.uuid-5c775f62-65a3-422d-ab21-35d90a20761a{fill-rule:evenodd;}.uuid-76e8569b-bfc5-4c90-8d9a-83164b1f884f{fill:#4cd5f7;}.uuid-5c775f62-65a3-422d-ab21-35d90a20761a{fill:#3a5ce9;}.uuid-ca7359b8-eb8e-453f-89f6-b50522f4dc66{fill:none;}.uuid-c6df55fb-bc8c-4e90-b474-6d32e0006d90{clip-path:url(#uuid-21311ace-5180-456a-a7e4-58eabfe422d5);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-21311ace-5180-456a-a7e4-58eabfe422d5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-ca7359b8-eb8e-453f-89f6-b50522f4dc66",
    x: 62.85,
    y: 58.42,
    width: 386.3,
    height: 389.77
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-8ec62a71-dd3c-42c7-aeea-444233969ade",
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-56ee2b07-32a4-41f5-94c2-b77a0b34685b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-1d7d64cb-2550-4081-b2ca-4e3017f2fa04"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-fafb9ac2-ea45-4fbd-8f73-6103598cc7a6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-883a4ab9-9c9e-4d38-85f3-1f2c4e3688f5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-c6df55fb-bc8c-4e90-b474-6d32e0006d90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-001d4f51-ca69-4453-bd71-a9d807388512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-d9a351fb-dfb0-4523-818a-5d929e9138b5",
    className: "uuid-76e8569b-bfc5-4c90-8d9a-83164b1f884f",
    d: "m380.75,104.29c80.51,64.88,91.43,183.89,24.82,268.88-66.34,86.8-187.48,100.98-271.04,28.28-83.87-74.63-95.99-201.71-26.55-280.49,69.67-77.1,192.01-83.21,272.78-16.67h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "uuid-7eb84a60-cf68-4c45-9ff1-695c363faa3a",
    className: "uuid-0ea754f9-13da-4021-ab15-134b2e5494a1",
    d: "m377.88,123.21c59.28,47.8,67.33,135.45,18.28,198.04-48.85,63.92-138.07,76.14-199.62,22.58-61.78-54.96-70.69-150.29-19.55-208.32,51.32-56.79,141.4-61.3,200.89-12.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-a4995506-df02-4234-857b-1ed1070f99af",
    className: "uuid-5c775f62-65a3-422d-ab21-35d90a20761a",
    d: "m372.74,141.23c44.95,36.32,51.04,102.91,13.85,150.49-37.04,48.59-104.67,56.54-151.36,15.83-46.84-41.77-53.58-112.89-14.81-156.98,38.9-43.15,107.22-46.58,152.32-9.34h0Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLh);
export default __webpack_public_path__ + "static/media/icon_lh.3e65b25ed0c4fd8846af6194a23496c1.svg";
export { ForwardRef as ReactComponent };